/* ZIZA: free tote popup v2 (snippets/ziza-free-tote-popup.liquid).
   Verschijnt alleen direct na een add-to-cart, nooit bij het laden van een
   pagina. 1-2 kledingitems: voortgang (max 1x per sessie). 3+ items zonder
   tote: kies je tote. Hoort bij de korting "Gratis tote bag bij 3 items".
   Vangnet op de cart-pagina: snippets/ziza-free-tote-cart.liquid.
   Conversie v1: "View cart" is de hoofdknop in de voortgangsstand, teksten
   komen uit data-attributen (EN/NL), cart-urls volgen de taal (/nl/cart).
   Verwijderen = deze file + de snippet + de render-regel in layout/theme.liquid. */
(function () {
  var KEY_CHOOSE = 'ziza-tote-choose-dismissed';
  var KEY_PROGRESS = 'ziza-tote-progress-shown';

  var overlay = document.getElementById('ZizaFreeTotePopup');
  if (!overlay) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var endsEpoch = parseInt(overlay.dataset.ends, 10);
  if (endsEpoch && Date.now() / 1000 >= endsEpoch) return;

  var minItems = parseInt(overlay.dataset.min, 10) || 3;
  var countTypes = (overlay.dataset.countTypes || '').split(',');
  var toteHandles = (overlay.dataset.toteHandles || '').split(',');

  var sheet = overlay.querySelector('.zt-sheet');
  var tilesWrap = overlay.querySelector('.zt-tiles');
  var tiles = overlay.querySelectorAll('.zt-tile');
  var cta = overlay.querySelector('.zt-cta.zt-only-choose');
  var errorEl = overlay.querySelector('.zt-error');
  var bars = overlay.querySelectorAll('.zt-progress span');
  var labelPick = overlay.dataset.labelPick || 'Pick a colour';
  var labelAdd = overlay.dataset.labelAdd || 'Add my free [color] tote';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || (root + 'cart');
  var selected = null;
  var isOpen = false;
  var lastFocus = null;

  function flag(key) { try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; } }
  function setFlag(key) { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
  function setText(sel, value) {
    Array.prototype.forEach.call(overlay.querySelectorAll(sel), function (el) { el.textContent = value; });
  }

  function select(tile) {
    if (sheet.dataset.mode !== 'choose') return;
    selected = tile;
    Array.prototype.forEach.call(tiles, function (t) { t.setAttribute('aria-pressed', t === tile ? 'true' : 'false'); });
    cta.disabled = false;
    cta.textContent = labelAdd.replace('[color]', tile.dataset.name);
  }

  function show(mode, qualifying) {
    if (isOpen) return;
    /* Niet over de nieuwsbrief-popup heen. */
    if (document.querySelector('.ziza-popup-overlay.is-open')) return;
    sheet.dataset.mode = mode;
    tilesWrap.classList.toggle('is-preview', mode === 'progress');
    Array.prototype.forEach.call(tiles, function (t) {
      t.setAttribute('aria-pressed', 'false');
      if (mode === 'progress') t.setAttribute('tabindex', '-1'); else t.removeAttribute('tabindex');
    });
    selected = null;
    cta.disabled = true;
    cta.textContent = labelPick;
    errorEl.style.display = 'none';
    setText('[data-zt-count]', qualifying);
    setText('[data-zt-have]', qualifying);
    setText('[data-zt-left]', Math.max(minItems - qualifying, 1));
    Array.prototype.forEach.call(bars, function (b, i) { b.classList.toggle('is-on', i < qualifying); });

    isOpen = true;
    /* v1.2: de nieuwsbrief-popup komt deze sessie niet meer. */
    setFlag('ziza-tote-shown');
    lastFocus = document.activeElement;
    overlay.hidden = false;
    overlay.classList.add('is-open');
    document.addEventListener('keydown', onKeydown);
    window.setTimeout(function () { overlay.querySelector('.zt-close').focus(); }, 30);
  }

  function close() {
    if (sheet.dataset.mode === 'choose') setFlag(KEY_CHOOSE);
    isOpen = false;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    var focusables = Array.prototype.filter.call(
      sheet.querySelectorAll('button:not([disabled]):not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  overlay.querySelector('.zt-close').addEventListener('click', close);
  overlay.querySelector('.zt-link-keep').addEventListener('click', close);
  overlay.addEventListener('click', function (event) { if (event.target === overlay) close(); });
  Array.prototype.forEach.call(tiles, function (tile) {
    tile.addEventListener('click', function () { select(tile); });
  });

  cta.addEventListener('click', function () {
    if (!selected) return;
    cta.disabled = true;
    errorEl.style.display = 'none';
    origFetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ id: parseInt(selected.dataset.variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        setFlag(KEY_CHOOSE);
        window.location.href = cartUrl;
      })
      .catch(function () {
        errorEl.style.display = 'block';
        cta.disabled = false;
      });
  });

  /* Na een add-to-cart: wagen tellen (zelfde afbakening als de korting). */
  function afterAdd() {
    origFetch(root + 'cart.js', { headers: { accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var qualifying = 0;
        var hasTote = false;
        cart.items.forEach(function (item) {
          if (toteHandles.indexOf(item.handle) !== -1) hasTote = true;
          if (countTypes.indexOf(item.product_type) !== -1) qualifying += item.quantity;
        });
        if (hasTote || qualifying < 1) return;
        if (qualifying >= minItems) {
          if (!flag(KEY_CHOOSE)) show('choose', qualifying);
        } else if (!flag(KEY_PROGRESS)) {
          setFlag(KEY_PROGRESS);
          show('progress', qualifying);
        }
      })
      .catch(function () {});
  }

  /* Alleen /cart/add triggert de popup (Dawn doet add-to-cart via fetch).
     Kleine vertraging zodat de cart-melding van het thema eerst verschijnt. */
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = origFetch.apply(window, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !isOpen) {
      result.then(function (res) { if (res && res.ok) window.setTimeout(afterAdd, 900); }).catch(function () {});
    }
    return result;
  };
})();
